// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3786":"a860e824737cf753","7336":"c742daa4e299ae42","8944":"2a5a52a1e3363658"}[chunkId] + ".js";
};